/* PreventivoAutoConfermaPage.jsx — pagina post-submit con CTA Area Cliente */
import { useLocation, Link, useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { CheckCircle2, ArrowRight, Clock, User } from "lucide-react";

export default function PreventivoAutoConfermaPage() {
  const { state } = useLocation();
  const nav = useNavigate();
  const r = state || {};
  const tracking = r.tracking_id || "—";
  const inviteToken = r.debug_invite_token;
  const otpUnverified = !!r.otp_unverified;
  const inviteSent = r.auto_invite_status === "invite_sent";
  const linked = r.auto_invite_status === "linked_existing";
  const already = r.auto_invite_status === "already_existing";

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 via-white to-slate-50 flex flex-col">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto w-full px-4 py-12">
        <div
          data-testid="prev-auto-success-card"
          className="rounded-3xl bg-white border border-emerald-200 shadow-xl p-8 md:p-12 text-center"
        >
          <div className="mx-auto w-20 h-20 rounded-full bg-emerald-100 flex items-center justify-center mb-6">
            <CheckCircle2 className="w-12 h-12 text-emerald-600" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-[#163321] mb-3">
            Richiesta inviata con successo!
          </h1>
          <p
            data-testid="prev-auto-tracking-id"
            className="inline-block px-4 py-2 rounded-full bg-slate-100 font-mono text-sm font-semibold text-slate-700 mb-6"
          >
            Tracking ID: {tracking}
          </p>
          <div className="flex items-center justify-center gap-2 text-slate-600 mb-8">
            <Clock className="w-5 h-5 text-amber-500" />
            <span>Riceverai il preventivo entro <b>4 ore lavorative</b>.</span>
          </div>

          {inviteSent && (
            <div
              data-testid="prev-auto-invite-cta"
              className="rounded-2xl bg-[#163321] text-white p-6 md:p-8 mb-4"
            >
              <h2 className="text-xl md:text-2xl font-bold mb-2">
                Crea il tuo Area Cliente in 30 secondi
              </h2>
              <p className="text-emerald-100 mb-5 text-sm md:text-base">
                I tuoi dati anagrafici sono <b>già pronti</b>. Scegli solo una password e gestisci tutte le tue polizze online.
              </p>
              <Link
                to={inviteToken
                  ? `/area-cliente/register?token=${inviteToken}`
                  : "/area-cliente/register"}
                data-testid="prev-auto-cta-create-account"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-amber-400 text-[#163321] font-bold hover:bg-amber-300 transition-all"
              >
                <User className="w-5 h-5" />
                Crea account ora
                <ArrowRight className="w-5 h-5" />
              </Link>
              <p className="text-xs text-emerald-200 mt-4">
                Hai già un account?{" "}
                <Link
                  to="/area-cliente/login"
                  className="underline font-medium hover:text-white"
                  data-testid="prev-auto-cta-login"
                >
                  Accedi
                </Link>
              </p>
            </div>
          )}

          {(linked || already) && (
            <div className="rounded-2xl bg-sky-50 border border-sky-200 p-6 mb-4">
              <p className="text-sky-800 mb-3">
                Hai già un Area Cliente con questa email — il preventivo è collegato al tuo profilo.
              </p>
              <Link
                to="/area-cliente/login"
                data-testid="prev-auto-cta-login-existing"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-sky-600 text-white font-medium hover:bg-sky-700"
              >
                Accedi all'Area Cliente
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          )}

          {otpUnverified && (
            <div className="rounded-2xl bg-amber-50 border border-amber-200 p-5 mb-4 text-left text-sm text-amber-900">
              Hai inviato la richiesta senza confermare il numero via SMS. Un nostro consulente ti contatterà
              entro 24h per validare i dati e procedere col preventivo.
            </div>
          )}

          <button
            onClick={() => nav("/")}
            data-testid="prev-auto-back-home"
            className="text-slate-500 text-sm underline hover:text-[#163321] mt-6"
          >
            Torna alla home
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
